import React, { Component } from 'react';
import AccountReturns from './AccountReturns';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';

class AccountDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            accountBalances: [],
            member: null
        }
    }

    static getDerivedStateFromProps(props, state) {
        const member = props.member;
        let accountBalances = [];
        props.accountBalances ? props.accountBalances.map(accountBalance => accountBalances.push(accountBalance)) : accountBalances = [];
        return {
            accountBalances: accountBalances,
            member: member
        }
    }

    render() {
        const { t } = this.props
        return (
            this.props.isAccountBalancesEmpty ? <div className="tabMessage">There are no transactions for the period chosen</div> :
                !this.state.accountBalances || this.state.accountBalances.length === 0 ? <div  className="tabMessage">{t('fetching') + " " + t('account') + " " + t('balances')}</div>
                        :
            <div
            // style={{marginLeft: "12px"}}
            >
                
                        <div>
                            <table className="table-responsive superlifeLegacyPlan accounts-funds" style={{ marginLeft: "-1px", marginRight: "1px" }}>
                                <col></col>
                                {
                                    this.props.products && this.props.products.map(product => product.scheme === "SLI"
                                        && product.accounts && <colgroup span={product.accounts.length}></colgroup>)
                                }
                                <thead>
                                    <tr>
                                        <th style={{ height: 30 }} rowSpan="3"></th>
                                        {
                                            !this.props.products ? ""
                                                : this.props.products.map(product =>
                                                    <th colSpan={product.accounts.length} scope="colgroup">{product.schemeName}</th>)
                                        }
                                        <th>{t('adviserHomePage:total')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.accountBalances.map((accountBalance, index) => 
                                            <tr key={index}>
                                               <td style={{
                                                   textAlign: 'left',
                                                   fontWeight: (accountBalance.balanceType === 'opening' ||  
                                                    accountBalance.balanceType === "closing") && 'bold'
                                               }}>{(accountBalance.description && accountBalance.description.includes("PIR") && this.props.member.pirRate)?
                                                    accountBalance.description + " (PIR:"+this.props.member.pirRate+"%)" : accountBalance.description
                                                }</td>
                                               {
                                                   accountBalance.accounts.map(account => 
                                                    <td>
                                                        {account.amount ? account.amount !== 0 ?
                                                            <CurrencyFormat value={Number(account.amount).toFixed(2)}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                prefix={'$'} /> : "-" : "-"
                                                        }
                                                    </td>
                                                    )
                                               }
                                               <td>
                                                    {accountBalance.totalAmt ? accountBalance.totalAmt !== 0 ?
                                                        <CurrencyFormat value={Number(accountBalance.totalAmt).toFixed(2)}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            prefix={'$'} /> : "-" : "-"
                                                    }
                                               </td>
                                            </tr>)

                                        // this.props.accountBalances.map((accountBalance, index) =>
                                        //     <tr key={index}>
                                        //         <td style={{
                                        //             textAlign: "left",
                                        //             fontWeight: (accountBalance.balanceType === "opening" ||
                                        //                 accountBalance.balanceType === "closing") && "bold"
                                        //         }}>{accountBalance.description}</td>
                                        //         {
                                        //             accountBalance.accounts.filter(account =>
                                        //                 account.account === "Member").map(acc =>
                                        //                     <td>{acc.amount ? acc.amount !== 0 ?
                                        //                         <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                        //                             displayType={'text'}
                                        //                             thousandSeparator={true}
                                        //                             prefix={'$'} /> : "-" : "-"}
                                        //                     </td>)
                                        //         }
                                        //         {
                                        //             accountBalance.accounts.filter(account =>
                                        //                 account.account === "Employer").map(acc =>
                                        //                     <td>{acc.amount ? acc.amount !== 0 ?
                                        //                         <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                        //                             displayType={'text'}
                                        //                             thousandSeparator={true}
                                        //                             prefix={'$'} /> : "-" : "-"}</td>)
                                        //         }
                                        //         {
                                        //             accountBalance.accounts.filter(account =>
                                        //                 account.account === "Voluntary").map(acc =>
                                        //                     <td>{acc.amount ? acc.amount !== 0 ?
                                        //                         <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                        //                             displayType={'text'}
                                        //                             thousandSeparator={true}
                                        //                             prefix={'$'} />
                                        //                         : "-" : "-"}</td>)
                                        //         }
                                        //         {
                                        //             accountBalance.accounts.filter(account =>
                                        //                 account.account === "KiwiSaver").map(acc =>
                                        //                     <td>{acc.amount ? acc.amount !== 0 ?
                                        //                         <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                        //                             displayType={'text'}
                                        //                             thousandSeparator={true}
                                        //                             prefix={'$'} />
                                        //                         : "-" : "-"}</td>)
                                        //         }
                                        //         {
                                        //             accountBalance.accounts.filter(account =>
                                        //                 account.account === "UK pension transfer").map(acc =>
                                        //                     <td>{acc.amount ? acc.amount !== 0 ?
                                        //                         <CurrencyFormat value={Number(acc.amount).toFixed(2)}
                                        //                             displayType={'text'}
                                        //                             thousandSeparator={true}
                                        //                             prefix={'$'} /> : "-" : "-"}</td>)
                                        //         }
                                        //         <td><CurrencyFormat value={Number(accountBalance.totalAmt).toFixed(2)}
                                        //             displayType={'text'}
                                        //             thousandSeparator={true}
                                        //             prefix={'$'} /></td>
                                        //     </tr>)
                                            }
                                </tbody>
                            </table>
                            <table>
                    <tbody>
                        <tr style={{ fontSize: "12px", textAlign: "top", }}>{t("AccountBalance:SubjectTo")}</tr>
                    </tbody>
                    </table>
                    <table style={{ marginTop: "10px" }}>
                        <tbody>
                            <tr style={{ fontSize: "12px", textAlign: "top", marginTop: "12px" }}>{t("AccountBalance:TheEmployerContributions")}</tr>
                        </tbody>
                    </table>
                    <table style={{ marginTop: "10px" }}>
                        <tbody>
                            <tr style={{ fontSize: "12px", textAlign: "top", marginTop: "12px" }}>{t("AccountBalance:TheTotalFunds")}</tr>
                        </tbody>
                    </table>
                    <table style={{ marginTop: "10px" }}>
                        <tbody>
                            <tr style={{ fontSize: "12px", textAlign: "top", marginTop: "12px" }}>{t("AccountBalance:NoteTheEmployerContributions")}</tr>
                        </tbody>
                    </table>
                        </div>
                
                <AccountReturns {...this.props} />
            </div> 
        )
    }
}

export default withTranslation()(AccountDetails);